<template src="./select.html"></template>

<script>
  export default {
    name: 'Select',
    props: {
      items: {
        type: Array
      },
      value: null,
      defaultLabel: null,
      numbered: false,
      disabled: false,
      readonly: false,
      centered: false,
      error: false,
      defaultSelectable: false,
    },
    data: function () {
      return {
        selectedValue: ''
      }
    },
    watch: {
      selectedValue: function () {
        this.$emit('selected', {id: this.selectedValue})
      },
      value: function () {
        var v = (this.value === null || this.value === undefined) ? '' : this.value
        this.selectedValue = v
      }
    },
    mounted: function () {
        this.$nextTick(() => {
          this.selectedValue = (this.value === null || this.value === undefined) ? '' : this.value
        });
    }
  }
</script>
